<!-- 个人信息补全 -->
<template>
  <div class="flex registerConBox">
    <leftMenu v-if="!ops.alreadyCompleted" />
    <div class="flex cogBgBox fdcolmun jcenter" style="height: 100%;">
      <alreadyCompleted v-if="ops.alreadyCompleted" />
      <div v-else class="regfisterRightConBox">
        <el-carousel
          ref="registerBodyCarouselRef"
          height="904px"
          :autoplay="false"
          :interval="0"
          arrow="never"
          :loop="false"
          class="registerBodyCarousel"
          indicator-position="outside"
        >
          <el-carousel-item>
            <detailsOfTheCompany ref="DetailsOfTheCompany" />
          </el-carousel-item>

          <el-carousel-item>
            <rakumartExperience ref="RakumartExperience" />
          </el-carousel-item>

          <el-carousel-item>
            <completeSuccess ref="CompleteSuccess" />
          </el-carousel-item>
        </el-carousel>
        <div class="stepIconList dip">
          <div
            class="stepBox"
            v-for="item in 3"
            :key="item"
            :class="{
              active: ops.step == item || (item == 3 && ops.step >= 3),
            }"
          ></div>
        </div>
      </div>
    </div>
    <div class="rakuYear">
      © Rakumart 2026
    </div>
  </div>
</template>
<script>
import ops from "./utils/opStore.js";
import leftMenu from "./components/model-leftMenu.vue";
import detailsOfTheCompany from "./components/model-detailsOfTheCompany.vue";
import rakumartExperience from "./components/model-rakumartExperience.vue";
import completeSuccess from "./components/model-completeSuccess.vue";
import alreadyCompleted from "./components/model-alreadyCompleted.vue";
export default {
  data() {
    return { ops };
  },
  components: {
    leftMenu,
    detailsOfTheCompany,
    rakumartExperience,
    completeSuccess,
    alreadyCompleted,
  },
  watch: {
    "ops.step"() {
      if (this.ops.alreadyCompleted) {
        return;
      }
      this.$nextTick(() => {
        if (this.$refs.registerBodyCarouselRef) {
          this.$refs.registerBodyCarouselRef.setActiveItem(this.ops.step - 1);
        }
      });
    },
  },
  created() {
    if (this.$route.query.email) {
      this.ops.formregister.email = this.$route.query.email;
    }
    this.checkSupplementStatus();
  },
  mounted() {
    if (this.ops.alreadyCompleted) {
      return;
    }
    this.ops.DetailsOfTheCompany = this.$refs.DetailsOfTheCompany;
    this.ops.RakumartExperience = this.$refs.RakumartExperience;
    this.ops.CompleteSuccess = this.$refs.CompleteSuccess;
    this.ops.registerBodyCarouselRef = this.$refs.registerBodyCarouselRef;
    this.$nextTick(() => {
      if (this.$refs.registerBodyCarouselRef) {
        this.$refs.registerBodyCarouselRef.setActiveItem(this.ops.step - 1);
      }
    });
  },
  methods: {
    checkSupplementStatus() {
      const userInfo = this.$store.state.userInfo;
      if (userInfo) {
        this.ops.setAlreadyCompleted(userInfo);
        return;
      }
      this.$api.EuropegetUserInfo().then((res) => {
        if (res.code != 0) {
          return;
        }
        this.$store.commit("userData", res.data);
        this.ops.setAlreadyCompleted(res.data);
      });
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
.registerConBox {
  height: 100vh;
  min-height: 100%;
  overflow: auto;
  background-color: white;
  position: relative;

  .cogBgBox {
    flex: 1;
    height: 100%;
    background-image: url("https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260512134339452999.png");
    background-repeat: no-repeat;
    background-position: center 150px;
    background-size: 3000px;
    background-color: white;
  }

  .rakuYear {
    position: absolute;
    right: 100px;
    bottom: 42px;
  }
}

.registerBodyCarousel {
  /deep/.el-carousel__indicators {
    display: none;
  }
  /deep/.el-carousel__item {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.stepIconList {
  gap: 12px;

  .stepBox {
    width: 30px;
    height: 8px;
    border-radius: 4px;
    background: var(--Gray-200, #eaecf0);
  }
  .active {
    background: var(--Gray-200, #009246);
  }
}
</style>
